import { render, staticRenderFns } from "./base_Fedit.vue?vue&type=template&id=34786969"
import script from "./base_Fedit.vue?vue&type=script&lang=js"
export * from "./base_Fedit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports